import { apiClient } from '@/lib/api'
import type { StandardResponse, PaginatedStandardResponse, PaginationInfo } from '@/types/api-response'
import { extractData, extractPaginatedData } from '@/types/api-response'
import type {
  EmailTemplateListDto,
  EmailTemplateDetailDto,
  CreateEmailTemplateRequest,
  UpdateEmailTemplateRequest,
} from '@/types/email-template'

export const adminEmailTemplateService = {
  async getTemplates(params: {
    category?: string
    key?: string
    page?: number
    limit?: number
  } = {}): Promise<{ data: EmailTemplateListDto[]; pagination: PaginationInfo }> {
    const searchParams = new URLSearchParams()
    if (params.category) searchParams.append('category', params.category)
    if (params.key) searchParams.append('key', params.key)
    searchParams.append('page', (params.page ?? 1).toString())
    searchParams.append('limit', (params.limit ?? 20).toString())

    const response = await apiClient.get<PaginatedStandardResponse<EmailTemplateListDto>>(
      `/api/v1/admin/email-templates?${searchParams.toString()}`
    )
    return extractPaginatedData(response.data)
  },

  async getTemplateById(id: string): Promise<EmailTemplateDetailDto> {
    const response = await apiClient.get<StandardResponse<EmailTemplateDetailDto>>(
      `/api/v1/admin/email-templates/${id}`
    )
    return extractData(response.data)
  },

  async createTemplate(data: CreateEmailTemplateRequest): Promise<EmailTemplateDetailDto> {
    const response = await apiClient.post<StandardResponse<EmailTemplateDetailDto>>(
      '/api/v1/admin/email-templates',
      data
    )
    return extractData(response.data)
  },

  async updateTemplate(id: string, data: UpdateEmailTemplateRequest): Promise<EmailTemplateDetailDto> {
    const response = await apiClient.put<StandardResponse<EmailTemplateDetailDto>>(
      `/api/v1/admin/email-templates/${id}`,
      data
    )
    return extractData(response.data)
  },

  async deleteTemplate(id: string): Promise<void> {
    await apiClient.delete(`/api/v1/admin/email-templates/${id}`)
  },
}
